import React, { useState } from "react";
import Modal from "react-modal";
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Logo from "../img/logo.png"

const customStyles = {
  content: {
    top: '57%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw', // Responsivo em largura
    maxWidth: '700px', // Limite máximo para largura
    height: 'auto', // Ajusta a altura com base no conteúdo
    maxHeight: '80vh', // Evita que ultrapasse a altura da viewport
    padding: '15px',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
    overflowY: 'auto', // Scroll automático se o conteúdo exceder a altura
    color: 'black',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
  },
};


// Defina seu elemento de aplicativo para acessibilidade
Modal.setAppElement('#root');

export const Header = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [userName, setUserName] = useState("");
  const [userWhatsapp, setUserWhatsapp] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [brandName, setBrandName] = useState(""); // Campo para o nome da marca
  const [selectedCategory, setSelectedCategory] = useState(""); // Nova categoria selecionada
  const notifySuccess = () => toast.success("Obrigado! Fale conosco no whatsapp, ou aguarde o nosso contato!");

  const recipientEmail = "gamaefreire@gmail.com"; // E-mail do destinatário

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
    setLoading(false);
    setFormVisible(false);
    setBrandName(""); // Reseta o nome da marca ao fechar
    setUserName("");
    setUserWhatsapp("");
    setUserEmail("");
    setSelectedCategory(""); // Reseta a categoria
    setAcceptedTerms(false);
  }

  function handleConclude() {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setFormVisible(true);
    }, 2000);
  }

  function handleFinalize() {
    const templateParams = {
      from_name: userName,
      from_whatsapp: userWhatsapp,
      from_email: userEmail,
      brand_name: brandName,
      brand_category: selectedCategory, // Nova categoria enviada
      to_email: recipientEmail,
    };

    // Envie o e-mail usando EmailJS
    emailjs.send("service_gzj313h", "template_mqgqfd8", templateParams, "VRAaTZA59RyX7in_2")
      .then((response) => {
        console.log('Email enviado com sucesso!', response.status, response.text);
        notifySuccess();

        // Aguarde 3 segundos antes de redirecionar
        setTimeout(() => {
          window.location.href = "https://api.whatsapp.com/send?phone=5582991023387&text=Ol%C3%A1%2C%20vim%20atrav%C3%A9s%20do%20site%20e%20tenho%20interesse%20em%20registrar%C2%A0minha%C2%A0marca%21";
        }, 4000); // 3000 ms = 3 segundos
      })
      .catch((err) => {
        console.error('Erro ao enviar o email:', err);
        alert('Falha ao enviar o email. Tente novamente.');
      });

  }

  return (
    <header id="header" style={{ marginTop: "70px" }}>
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>{props.data ? props.data.title : "Loading"}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

